"use client";

import React from "react";
import { ArrowRight, Star, Users } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function TheFutureOfOurState() {
  const {
    ref: leftRef,
    isVisible: leftVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.15
  });
  const {
    ref: rightRef,
    isVisible: rightVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.15
  });
  const {
    ref: statsRef,
    isVisible: statsVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.2
  });
  return <section data-section-id="230560" id="the-game-plan" className="bg-background text-foreground relative overflow-hidden min-h-0 flex items-center">
      {}
      <div className="absolute inset-0 pointer-events-none" aria-hidden="true">
        <div className="absolute top-0 left-0 w-2/3 h-full opacity-10" style={{
        background: "radial-gradient(ellipse at 20% 50%, var(--primary) 0%, transparent 60%)"
      }} />
        <div className="absolute top-0 right-0 w-1/2 h-full opacity-5" style={{
        background: "radial-gradient(ellipse at 80% 30%, var(--secondary) 0%, transparent 60%)"
      }} />
        {}
        <div className="absolute inset-0 opacity-5" style={{
        backgroundImage: "linear-gradient(var(--border) 1px, transparent 1px), linear-gradient(90deg, var(--border) 1px, transparent 1px)",
        backgroundSize: "60px 60px"
      }} />
      </div>

      <div className="relative z-10 w-full max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12 lg:py-16">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-16 items-center">

          {}
          <div ref={leftRef} className={`flex flex-col gap-6 transition-all duration-1000 ease-out ${leftVisible ? "opacity-100 translate-x-0" : "opacity-0 -translate-x-16"}`}>
            {}

            <div className="flex justify-start mb-0">
              <Link to="/">
                <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1662846/img/Adobe Express - file.png" alt="Send It Fit mobile personal training service branding and logo design" className="max-w-[320px] object-cover object-center !h-[150px] !w-[380px] sm:max-w-[426px]" loading="lazy" />
              </Link>
            </div>

            {}
            <div className="flex flex-col gap-2">
              <h1 className="font-header font-bold leading-none tracking-tighter" style={{
              fontSize: "clamp(3rem, 8vw, 6rem)",
              textShadow: "var(--text-shadow-val, 2px 2px 0px var(--foreground))"
            }}>
                <span className="block text-primary" style={{
                textShadow: "inherit"
              } as React.CSSProperties}>Mobile</span>
                <span className="block" style={{
                color: "var(--primary)",
                textShadow: "inherit"
              } as React.CSSProperties}>
                  personal training.
                </span>
                <style jsx>{`
                  h1 { --text-shadow-val: 2px 2px 0px var(--foreground); }
                  @media (min-width: 640px) {
                    h1 { --text-shadow-val: 6px 6px 0px var(--foreground); }
                  }
                `}</style>
              </h1>
            </div>

            <div className="inline-flex items-center gap-2 w-fit px-4 py-2 rounded-lg border border-border bg-card/50 backdrop-blur-sm">
              <Star className="size-3.5 fill-primary text-primary animate-pulse" />
              <span className="text-foreground text-xs font-mono font-medium tracking-widest uppercase">Making fitness fun, and funny</span>
            </div>

            {}
            <div className="flex flex-col gap-3">
              <p className="font-default text-lg sm:text-xl text-foreground leading-relaxed max-w-md">We deliver results, literally. By actually coming to you.<br /><br />Your house. Condo gym. Nearby park. You name the place, we'll be there.</p>
              
            </div>

            {}
            <div className="flex items-center gap-3">
              <div className="h-px flex-1 max-w-16" style={{
              background: "var(--primary)"
            }} />
              <div className="h-1.5 w-1.5 rounded-lg" style={{
              background: "var(--foreground)"
            }} />
              <div className="h-px flex-1 max-w-8" style={{
              background: "var(--border)"
            }} />
            </div>

            {}
            <div className="flex flex-col sm:flex-row gap-4 items-start">
              {}
              <div className="relative">
                {}
                <span className="absolute inset-0 rounded-lg animate-ping opacity-30" style={{
                background: "var(--primary)",
                animationDuration: "2s"
              }} aria-hidden="true" />
                <span className="absolute inset-0 rounded-lg animate-ping opacity-20" style={{
                background: "var(--primary)",
                animationDuration: "2s",
                animationDelay: "0.5s"
              }} aria-hidden="true" />
                <Button asChild size="lg" className="relative z-10 font-default font-bold text-base px-8 py-6 rounded-lg text-primary-foreground shadow-md sm:shadow-xl border-2 border-foreground hover:-translate-y-1 transition-transform" style={{
                background: "var(--primary)"
              }}>
                  <Link to="https://wa.me/6588990728">
                    WhatsApp Us!
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" className="size-5 ml-2 animate-pulse" aria-hidden="true">
                      <path d="M12 3C7.02944 3 3 7.02944 3 12C3 13.9021 3.58891 15.6666 4.59413 17.1213L3 21L6.87868 19.4059C8.33338 20.4111 10.0979 21 12 21C16.9706 21 21 16.9706 21 12C21 7.02944 16.9706 3 12 3Z" fill="#F2E4D0" stroke="#E8734A" strokeWidth="2" />
                      <path d="M15.05 12.54C14.54 12.03 13.86 11.75 13.14 11.75C12.42 11.75 11.74 12.03 11.23 12.54L10.46 13.31C10.28 13.21 10.1 13.1 9.93 12.98C9.44 12.64 8.99 12.24 8.59 11.78C8.23 11.37 7.92 10.93 7.67 10.46C7.55 10.24 7.44 10.02 7.35 9.8L8.12 9.03C8.63 8.52 8.91 7.84 8.91 7.12C8.91 6.4 8.63 5.72 8.12 5.21L7.12 4.21C6.61 3.7 5.93 3.42 5.21 3.42C4.49 3.42 3.81 3.7 3.3 4.21L2.54 4.97C2.03 5.48 1.75 6.16 1.75 6.88C1.75 9.58 2.81 12.17 4.72 14.08C6.63 15.99 9.22 17.05 11.92 17.05C12.64 17.05 13.32 16.77 13.83 16.26L14.59 15.5C15.1 14.99 15.38 14.31 15.38 13.59C15.38 12.87 15.1 12.19 14.59 11.68L15.05 12.54Z" fill="#E8734A" transform="translate(4, 4) scale(0.8) rotate(-15, 8, 8)" />
                    </svg>
                  </Link>
                </Button>
              </div>

              <Button asChild variant="outline" size="lg" className="font-default font-semibold text-base px-8 py-6 rounded-lg border-2 border-foreground text-foreground hover:bg-primary hover:text-primary-foreground transition-colors">
                
              </Button>
            </div>

            {}
            
          </div>

          {}
          <div ref={rightRef} className={`relative flex items-center justify-center transition-all duration-1000 ease-out delay-200 ${rightVisible ? "opacity-100 translate-x-0" : "opacity-0 translate-x-16"}`}>
            {}
            <div className="absolute inset-0 rounded-lg opacity-20 blur-3xl" style={{
            background: "var(--primary)"
          }} aria-hidden="true" />

            {}
            <div className="relative w-full max-w-sm sm:max-w-md lg:max-w-full rotate-2">
              {}
              <div className="relative w-full aspect-[3/4] overflow-hidden rounded-lg shadow-xl sm:shadow-4xl border-4 border-foreground">
                <img src="https://fun-bengal.10web.cloud/wp-content/uploads/2026/05/ChatGPT-Image-May-6-2026-01_21_54-PM.png" data-wvc-srcset="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1662846/img/retro_fitness_trainer_singapore.png-wvc-srcset" data-wvc-sizes="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1662846/img/retro_fitness_trainer_singapore.png-wvc-sizes" alt="Professional personal trainer demonstrating retro athletic vintage style fitness coaching in Singapore" className="w-full h-full object-cover object-center grayscale-[0.2] sepia-[0.1]" loading="eager" src="https://senditfit.com/wp-content/uploads/2026/05/send-it-fit-trainers.png" src="https://senditfit.com/wp-content/uploads/2026/05/Hero--scaled.jpg" />
                {}
                <img className="absolute inset-0" style={{
                background: "linear-gradient(180deg, transparent 60%, var(--background) 100%)"
              }} aria-hidden="true" src="https://senditfit.com/wp-content/uploads/2026/05/send-it-fit-trainers-1.png" alt="" src="https://senditfit.com/wp-content/uploads/2026/05/send-it-fit-trainers-2.png" />
              </div>

              {}
              <div className="absolute inset-0 rounded-lg border-2 opacity-30 pointer-events-none -translate-x-4 translate-y-4" style={{
              borderColor: "var(--primary)"
            }} aria-hidden="true" />

              {}
              

              {}
              <div className="absolute bottom-16 -right-2 sm:-right-6 bg-card border-2 border-foreground rounded-lg px-4 py-3 shadow-sm sm:shadow-lg rotate-3">
                <p className="font-mono text-xs text-foreground/70 mb-0.5 uppercase">You've held off long enough</p>
                <p className="font-serif font-bold text-xl" style={{
                color: "var(--primary)"
              }}>The Time is Now</p>
              </div>

              {}
              {["absolute top-0 right-0 -translate-y-2 translate-x-2", "absolute top-0 left-0 -translate-y-2 -translate-x-2"].map((pos, i) => <Star data-index={i} key={i} className={`${pos} size-6 fill-primary text-foreground opacity-90`} aria-hidden="true" />)}
            </div>
          </div>
        </div>
      </div>
    </section>;
}